import { FC, useEffect } from "react";
import { Box } from "@mui/material";
import { CommonStyle, ReusableCTUI } from "Components";
import { PatientInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "Constant/RouteUrls";
import CommonFormatter from "Utils/Common.Formatter";
import { setFormLoader } from "Redux/Screen/Action";
import { useDispatch } from "react-redux";

const EditTeam: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedPrgm, patientInfo }: PatientInitialStateType =
    useSelector((state: any) => state?.patient);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2;
  const careId = selectedPrgm.careplanId;
  const editUI = selectedPrgm.teamMember || isAdmin;

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "edit-team",
      label: "Edit Team",
      path: `/${RouteUrls.hs}/${RouteUrls.patient}/` +
        `${patientInfo.id}/${RouteUrls.carePlan}/` +
        `${selectedPrgm.careplanId}/${RouteUrls.editTeam}`,
      level: 5,
      link: RouteUrls.editTeam,
      navType: "patient",
    });
  }, [careId]);

  const handleSave: () => void = () => {
    dispatch(setFormLoader(false));
    navigate(`/${RouteUrls.hs}/${RouteUrls.patient}/` +
      `${patientInfo.id}/${RouteUrls.clinicalSummary}`)
  }

  return (
    <Box
      sx={{ ...CommonStyle.sxWhiteBox }}
      overflow={"auto"}
      px={2}
      width={"91%"}
    >
      <ReusableCTUI
        addAddProviders={editUI}
        displayNextBtn={false}
        displaySaveBtn={true}
        displaySaveNextBtn={false}
        editAddProviders={editUI}
        openAllForSA={isAdmin}
        prgmDetails={selectedPrgm}
        editCareTeam={isAdmin}
        filterForm1EmptyFields={false}
        filterForm2EmptyFields={false}
        handleSave={handleSave}
      />
    </Box>
  );
};

export default EditTeam;